import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

import { Workflow } from '../workflows/workflow.model';

@Component({
  selector: 'app-template-select',
  templateUrl: './template-select.component.html',
  styleUrls: ['./template-select.component.scss']
})
export class TemplateSelectComponent implements OnInit {

  workflows: Workflow[];

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.workflows = this.data.workflows;
  }

}



// WEBPACK FOOTER //
// ./src/app/templates/template-select.component.ts